import AiDevelopmentStoryPage from "../../pages/aiDevelopment/AiDevelopmentStoryPage";

const route = { key: "aiDevelopmentStory", path: "/ai-development/stories/:id", component: AiDevelopmentStoryPage,
  permission: "ai.development.read", private: true, layout: "main", icon: "faCode", group: "aiDevelopment", order: 11 };
export default route;
